import { apiEndpoint } from "@/services/map-town";
import axios from "axios";
import React, { useEffect, useState } from "react";

const PrizePopUp = (props) => {
  const [prizes, setPrizes] = useState([]);

  useEffect(() => {
    fetchPrizesAsync();
  }, []);

  const fetchPrizesAsync = async () => {
    let config = {
      method: "get",
      url: `${apiEndpoint}v1/prizes`,
    };

    try {
      const response = await axios(config);

      setPrizes(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div>
      <div className="text-center mb-12 md:mb-20">
        <h2 className="text-28 md:text-40 leading-9 font-semibold mb-3">
          Share your Green Home and Win!
        </h2>

        <h3 className="text-lg max-w-xl mx-auto">
          Share how you’re greening up your home and stand to win fantastic
          prizes!
        </h3>
      </div>

      <div className="grid md:grid-cols-3 gap-12 md:gap-8">
        {prizes?.map((prize, index) => (
          <figure key={prize.position}>
            <div className="mb-6 md:mb-7">
              <img src={prize.image_url} alt="" />
            </div>

            <h2
              className="text-2xl md:text-3xl font-semibold mb-5 md:mb-2"
              dangerouslySetInnerHTML={{ __html: prize.name }}
            />

            <div
              className="text-lg leading-6"
              dangerouslySetInnerHTML={{ __html: prize.description }}
            />
          </figure>
        ))}
      </div>
    </div>
  );
};

export default PrizePopUp;
